export function isVariant(product: CrystallizeProduct | CrystallizeProductVariant): product is CrystallizeProductVariant {
  return 'sku' in product && !!product.sku
}

export function getTitle(product: CrystallizeProduct | CrystallizeProductVariant) {
  if (isVariant(product)) {
    return product.components.title || product.name
  }
  else {
    const variant = getDefaultVariant(product)
    return variant?.components?.title
      || variant?.name
      || product.components.tittel
      || product.components.title
      || product.name
  }
}

export function getDefaultVariant(product: CrystallizeProduct) {
  return product.variants.find(it => it.isDefault) ?? product.variants[0]
}

export function getProductCard(product: CrystallizeProduct, cartItems?: CartItemDto[]) {
  const variant = getDefaultVariant(product)
  const cartItem = cartItems?.find(it => it.productId === variant?.sku)
  return {
    title: getTitle(product),
    subtitle: variant?.components.subtitle || product.components.subtitle,
    illustration: product.components.illustration,
    // FIXME: This only works as long as the route path is the same as the Crystallize path. Consider using named routes instead.
    href: product.path,
    variant,
    isLastAdded: !!cartItems && !!cartItem && cartItems.indexOf(cartItem) === cartItems.length - 1,
    isInCart: !!cartItem,
  }
}

export type ProductCard = ReturnType<typeof getProductCard>
